<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/home"></ion-back-button>
    </ion-buttons>
    <ion-title>Breeds Info</ion-title>
    <ion-buttons slot="primary">
      <ion-button [routerLink]="['/chats']"><ion-icon name="chatbox" slot="icon-only"></ion-icon></ion-button>
      <ion-button [routerLink]="['/notifications']"><ion-icon name="notifications"
          slot="icon-only"></ion-icon></ion-button>
      <ion-button [routerLink]="['/account']"><ion-icon name="menu-outline" slot="icon-only"></ion-icon></ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content color="lightmimbo">
  <div class="ion-padding ion-text-center" *ngIf="isLoading">
    <ion-spinner color="primary"></ion-spinner>
  </div>
  <ion-grid *ngIf="!isLoading">
    <ion-row>
      <ion-col sizeXl="10" offsetXl="1">
        <ion-segment value="dogs" [(ngModel)]="filter" (ionChange)="loadBreeds()" class="margin-bottom">
          <ion-segment-button value="dogs">
            <ion-label>
              Dogs
            </ion-label>
          </ion-segment-button>
          <ion-segment-button value="cats">
            <ion-label>
              Cats
            </ion-label>
          </ion-segment-button>
        </ion-segment>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
        <div class="ion-text-center">
          <ion-button color="primary" (click)="selectBreed()" class="btn">
            <ion-icon name="list-outline" slot="start"></ion-icon>
            Select Breed
          </ion-button>
          <ion-button color="primary" (click)="randomizeBreed()" class="btn">
            <ion-icon name="shuffle-outline" slot="start"></ion-icon>
            Random Breed
          </ion-button>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
  <ion-grid *ngIf="!isLoading && filter == 'dogs'">
    <ion-row>
      <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
        <ion-card class="post">
          <div class="ion-padding ion-text-center" *ngIf="!dogImageLoaded">
            <ion-spinner color="primary"></ion-spinner>
          </div>
          <img [src]="selectedDogBreed.imageUrl" width="100%" (load)="onImageLoad()" [class.loaded]="dogImageLoaded" />
          <ion-card-header>
            <ion-card-title color="darkmimbo">{{selectedDogBreed.name}}</ion-card-title>
            <ion-card-subtitle>{{selectedDogBreed.description}}</ion-card-subtitle>
          </ion-card-header>
          <ion-card-content>
            <div class="ion-padding-bottom" *ngIf="selectedDogBreed.lifeSpan">
              <h5>Life Span:</h5>
              <ion-label>{{selectedDogBreed.lifeSpan}} years on average</ion-label>
            </div>
            <div class="ion-padding-bottom" *ngIf="selectedDogBreed.weightKg">
              <h5>Weight:</h5>
              <ion-label>Around {{selectedDogBreed.weightKg}} kg </ion-label>
            </div>
            <div *ngFor="let item of dogRatings | keyvalue" class="ion-padding-bottom">
              <h5>{{ item.value }}</h5>
              <div *ngFor="let dot of getArray(5); let i = index" class="dots dot"
                [class.filled]="i < selectedDogBreed[item.key]">

              </div>
              <span class="num">{{ selectedDogBreed[item.key] }}/5</span>
            </div>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>
  </ion-grid>
  <ion-row *ngIf="filter == 'cats' && !isLoading">
    <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
      <ion-card class="post">
        <div class="ion-padding ion-text-center" *ngIf="!catImageLoaded">
          <ion-spinner color="primary"></ion-spinner>
        </div>
        <img [src]="selectedCatBreed.imageUrl" width="100%" (load)="onImageLoad()" [class.loaded]="catImageLoaded" />
        <ion-card-header>
          <ion-card-title color="darkmimbo">{{selectedCatBreed.name}}</ion-card-title>
          <ion-card-subtitle>{{selectedCatBreed.description}}</ion-card-subtitle>
        </ion-card-header>
        <ion-card-content>
          <div class="ion-padding-bottom" *ngIf="selectedCatBreed.lifeSpan">
            <h5>Life Span:</h5>
            <ion-label>{{selectedCatBreed.lifeSpan}} years on average</ion-label>
          </div>
          <div class="ion-padding-bottom" *ngIf="selectedCatBreed.weightKg">
            <h5>Weight:</h5>
            <ion-label>Around {{selectedCatBreed.weightKg}} kg </ion-label>
          </div>
          <div *ngFor="let item of catRatings | keyvalue" class="ion-padding-bottom">
            <h5>{{ item.value }}</h5>
            <div *ngFor="let dot of getArray(5); let i = index" class="dots dot"
              [class.filled]="i < selectedCatBreed[item.key]">

            </div>
            <span class="num">{{ selectedCatBreed[item.key] }}/5</span>
          </div>
        </ion-card-content>
      </ion-card>
    </ion-col>
  </ion-row>
</ion-content>